import { useTranslation } from 'react-i18next';

import { useStudentTutorDetail } from '@/store';

type Props = {
  studentId: string;
};

export const StudentTutor: React.FC<Props> = ({ studentId }) => {
  const { tutor } = useStudentTutorDetail(studentId);
  const { t } = useTranslation();

  if (!tutor) return t('TUTOR_NOT_ASSIGNED');

  return <div>{`${tutor.name} ${tutor.lastName}`}</div>;
};
